
const digest = '955e7391d15258885e28b75a035d7dfe8c192eb2fe6e9a4bde9f5405a1752b03';
const classes = {"wrapper":"_wrapper_zrjls_1","icon":"_icon_zrjls_8","title":"_title_zrjls_17"};
const css = `._wrapper_zrjls_1 {
  font-family: Rubik, sans-serif;
  display: inline-block;
  width: 100%;
  margin-bottom: 30px;
}

._icon_zrjls_8 {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  background: url("/dist/icons/react/folder-solid.svg") no-repeat center;
  background-size: contain;
  margin-bottom: 15px;
}

._title_zrjls_17 {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  